import React from 'react';

const GestaoAVistaExportContext = React.createContext();

export default GestaoAVistaExportContext;
